export function parseError(error: unknown) {
  const axiosError = error as {
    response?: { data?: { error?: { message?: string } } };
  };

  if (axiosError?.response?.data?.error?.message) {
    return axiosError.response.data.error.message;
  }

  if (error instanceof Error) {
    return error.message;
  }
}
